import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
name: 'approvalsDataFilter',
pure: false
})

export class ApprovalsDataFilterPipe implements PipeTransform {

transform(names: any[], terms: string): any[] {
  let transfer = "transfer";
  let payment = "payment";

  if (!names) return [];
  if (!terms) return names;

  terms = terms.toLowerCase();
  terms = terms.replace(',', '.');

  if (terms.substr(0, 3) === "pag" && terms.length<=9) {
    terms = payment.toLowerCase();
  }
  if (terms.substr(0, 3) === "bol" && terms.length<=6) {
    terms = payment.toLowerCase();
  }
  if (terms.substr(0, 5) === "trans" && terms.length<=13) {
    terms = transfer.toLowerCase();
  }
  else {
    return names.filter((it) => {
    return JSON.stringify(it).toLowerCase().includes(terms);
    });
  }

  terms = terms.toLowerCase();

  return names.filter((it) => {
    return JSON.stringify(it).toLowerCase().includes(terms);
  });

}
}
